const $ = window.jQuery;

// const passiveEventListener
// Test via a getter in the options object to see if the passive property is accessed
//https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
let supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function() {
      supportsPassive = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}

let raf = false;

const elements = [];

const event = new Event('inView');

const isInViewport = (element) => {
	const rect = element.getBoundingClientRect();
	const html = document.documentElement;
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || html.clientHeight) &&
		rect.right <= (window.innerWidth || html.clientWidth)
	);
}

const windowHandler = () => {
	elements.forEach((el) => {
		if (isInViewport(el)) {
			el.dispatchEvent(event);
		}
	});
	raf = false;
};

const windowScroll = (e) => {
	if (raf === false) {
		raf = true;
		requestAnimationFrame(windowHandler);
	}
};


window.addEventListener('scroll', windowScroll, supportsPassive ? { passive: true } : false);


export function addElements(element) {
	elements.push(element);
};

setTimeout(() => {
	windowScroll(); // trigger the scroll
},16);
